import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../../common/html/element'
import { COMPONENTS } from '../../../routers/constants'
import { selectCompanyInfo } from '../store/slice'

export const Standard = () => {
  const { organizationId } = useSelector(selectCompanyInfo)

  return (
    <>
      <div className="fw600">
        <Translate value="alertDetail.FIINGROUP_PREDICTIVE_MODEL" />
      </div>
      <div className="mt1">
        <Translate value="alertDetail.FIINGROUP_PREDICTIVE_MODEL_NOTE" />
      </div>
      <Element className="textEnd mt1" style={{ color: '#2C73E8' }}>
        <Link
          to={`${COMPONENTS.companyAnalysis.components.score.components.corporateRiskScore.route}?organizationId=${organizationId}`}
          target="_blank"
        >
          <Translate value="alertDetail.BUY_SCORE_INFORMATION" />
        </Link>
      </Element>
    </>
  )
}
